import LeaderSelect from 'src/containers/groups/registration/leaderSelect';
import { GroupsRegistrationComponent } from 'src/assets/styles/components/groupsRegistration';
import { StepCard } from '../styles';
import StepProgress from './StepProgress';

const GroupSelectionStep = ({ groupInputs, setGroupInputs, setStep, backStep }) => (
  <StepCard>
    <GroupsRegistrationComponent className="embedded">
      <StepProgress currentStepId="selectGroup" />
      <LeaderSelect
        inputs={groupInputs}
        setInputs={setGroupInputs}
        setStep={setStep}
        next="summary"
        backStep={backStep}
        fromConexion
      />
    </GroupsRegistrationComponent>
  </StepCard>
);

export default GroupSelectionStep;
